module.exports = __webpack_public_path__ + "img/ndaily.eaacc3a.gif";